import { createFileRoute } from '@tanstack/react-router';
import { SettingsManager } from '../../components/admin/SettingsManager';

export const Route = createFileRoute('/admin/settings')({
  component: SettingsTab,
});

function SettingsTab() {
  return <SettingsManager />;
}
